import React, { Component } from 'react';
import { withRouter } from 'react-router';
import styled from 'styled-components';
import { Mutation } from 'react-apollo';
import gql from 'graphql-tag';

import { LoadingButton } from '../Buttons';
import NewForm, { TextField, CheckboxGroupField, PrivacyPolicyField } from './NewForm';

const StyledInuiryForm = styled.div`
  margin: 0 auto;
  max-width: ${p => p.theme.globalWidthSmall};
`;

const Row = styled.div`
  display: flex;
  margin: 0 -${p => p.theme.gutterXSmall};
`;

const Column = styled.div`
  flex: 1;
  margin: 0 ${p => p.theme.gutterXSmall} 30px ${p => p.theme.gutterXSmall};
`;

const MessageText = styled.div`
  text-align: center;
`;

const mapValuesToFields = values => {
  const fields = [
    {
      key: 'input_1',
      value: values.name || null
    },
    {
      key: 'input_4',
      value: values.email || null
    },
    {
      key: 'input_5',
      value: values.phone || null
    },
    {
      key: 'input_2',
      value: values.regNumber || null
    },
  ];

  values.types.forEach((value, i) => {
    fields.push({
      key: 'input_12_' + (i + 1),
      value: value
    });
  });

  return fields;
};

export function PartRenovationForm(props) {
  return <NewForm
    {...props}
  >
    <Row>
      <Column>
        <TextField
          name="name"
          label="Firmanavn"
          required
        />
      </Column>
    </Row>

    <Row>
      <Column>
        <TextField
          type="email"
          name="email"
          label="E-post"
          required
          validate={(email) => {
            if (/(.+)@(.+){2,}\.(.+){2,}/.test(email)) {
              return;
            }

            return 'Må være en gyldig e-post adresse';
          }}
        />
      </Column>

      <Column>
        <TextField
          type="phone"
          name="phone"
          label="Telefon"
          required
        />
      </Column>

      <Column>
        <TextField
          name="regNumber"
          label="Registreringsnummer"
          required
        />
      </Column>
    </Row>

    <Row>
      <Column>
        <CheckboxGroupField
          name="types"
          label="Hva ønsker du tilbud på?"
          required
          options={{
            Motor: 'Motor',
            Gir: 'Gir',
            Turbo: 'Turbo',
            Topplokk: 'Topplokk'
          }}
        />
      </Column>
    </Row>

    <Row>
      <Column>
        <PrivacyPolicyField
          name="privacy"
          required
          fieldMissingMessage="Du må godkjenne personvernerklæringen"
        />
      </Column>
    </Row>
    <LoadingButton type="submit" loading={props.disabled}>
      Send inn
    </LoadingButton>
  </NewForm>;
}

export default function PartRenovationFormController({ formId }) {
  return <StyledInuiryForm>
    <Mutation
      mutation={gql`
      mutation submitForm($submission: GFFormSubmission $id: Int) {
          submission:postGFFormSubmission(
            id: $id
            submission: $submission
          ){
            is_valid
            page_number
            source_page_number
            confirmation_message
          }
        }
    `}
    >
      {(submit, { data, loading, error }) => {
        if (data && data.submission) {
          return <MessageText
            dangerouslySetInnerHTML={{
              __html: data.submission.confirmation_message
            }}
          />;
        }

        return <div>
          {error && <MessageText>
            {error.toString()}
          </MessageText>}
          <PartRenovationForm
            disabled={loading}
            onSubmit={(values) => {
              submit({
                variables: {
                  id: formId,
                  submission: {
                    fields: mapValuesToFields(values)
                  }
                }
              }).catch((error) => {
                console.error(error);
              });
            }}
          />
        </div>;
      }}
    </Mutation>
  </StyledInuiryForm>;
};
